import { Module } from '@nestjs/common';
import { WareHouseSampleModule } from '../warehouse/processor/warehouse-sample.module';
import { BullArenaUIProvider } from './bull-arena-ui-provider';

@Module({
    imports: [WareHouseSampleModule],
    exports: [],
    providers: [BullArenaUIProvider],
})
export class QueueUIModule { }